const GENERIC_PLAN_LABELS = new Set(["trial", "expired", "plan expired"]);

const stripTrailingPlanSuffix = (value: string) =>
  value.replace(/\s*[Pp]lan\s*$/, "").trim();

const normalizeCandidate = (value?: string | null) => {
  const trimmed = (value || "").trim();
  if (!trimmed) return "";

  const stripped = stripTrailingPlanSuffix(trimmed);
  if (!stripped) return "";
  if (GENERIC_PLAN_LABELS.has(stripped.toLowerCase())) return "";

  return stripped;
};

interface ResolveUsagePlanDisplayLabelInput {
  summaryPlanName?: string | null;
  userPlanName?: string | null;
  planDisplayText?: string | null;
  fallbackLabel: string;
}

export const resolveUsagePlanDisplayLabel = ({
  summaryPlanName,
  userPlanName,
  planDisplayText,
  fallbackLabel,
}: ResolveUsagePlanDisplayLabelInput): string => {
  const displayText =
    normalizeCandidate(summaryPlanName) ||
    normalizeCandidate(userPlanName) ||
    normalizeCandidate(planDisplayText) ||
    stripTrailingPlanSuffix(fallbackLabel.trim()) ||
    fallbackLabel.trim();

  return displayText;
};
